import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import * as UserActions from '../../actions/UserActions'
import * as Helper from '../../utils/Helper'
import Header from './parts/Header'
import Footer from '../after_login/parts/Footer'

// WaitVerification
const WaitVerification = (props) => {

  let navigate = useNavigate();
  let dispatch = useDispatch();

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

  }

  return (
    <div>

      <div style={{
        // backgroundColor: '#0C3966',
        backgroundColor: '#008CC8',
        height: 800,
      }}>

        {/* header */}
        <Header />


        <div>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="3" xs="12" />
            <Col md="6" xs="12" style={{ textAlign: 'left' }}>

              <div className="shadow2dp" style={{
                backgroundColor: '#ffffff',
                padding: 20,
              }}>

              <Row style={{
                marginTop: 10,
                marginBottom: 10,
              }}>
                <Col md="12" xs="12">
                  <span>
                    確認メールを送信させて頂きました。
                    <br/>
                    お手数ですが、確認メール内のURLをクリックして登録を完了して頂けますでしょうか。
                  </span>
                </Col>
              </Row>
            </div>

            </Col>
            <Col md="3" xs="12" />
          </Row>
        </div>

      </div>

      {/* fooder */}
      <Footer />

    </div>
  )
}

export default WaitVerification
